import { all, put, select, takeEvery } from 'redux-saga/effects';
import { Action } from 'typescript-fsa';

import { NAVIGATION, VIRTUAL_CARDS } from 'common/constants';
import { checkIfMarkRead, messageSent } from 'state/entities/conversations';
import { navigate } from 'state/router';
import settings from 'settings';
import { closeLauncher, navigateDashboardView, navigateView, playSound, setLauncherState, startAnimateTitle, floaterIgnoredCount, floaterIgnoredLast, floaterClosedLast } from 'state/ui';
import { isLauncherOpenSelector, isWidgetOpen, launcherSelector, rpPreviewModeSelector } from 'state/ui/ui.selectors';
import { sizes } from 'style/variables';
import { SocketMessage } from 'types';
import customWindow from '../../utility/storage/customWindow';

function* messageSentSaga(action: Action<SocketMessage>) {
  const { authorId, conversationId } = action.payload;
  if (authorId !== 'client') {
    yield put(playSound());
    yield put(startAnimateTitle({ authorId }));
    yield put(checkIfMarkRead({ conversationId }));
  }

  // @ts-ignore
  const isOpen = yield select(isWidgetOpen);
  if (!isOpen) {
    if (sizes.isMobile) {
      yield put(
        navigate({
          viewId: NAVIGATION.CONVERSATIONS,
          params: { conversationId }
        })
      );
    } else {
      yield put(setLauncherState({ cardIds: [VIRTUAL_CARDS.MESSAGES._id], open: true }));
    }
  } else {
    // @ts-ignore
    const isLauncherOpen = yield select(isLauncherOpenSelector);
    if (isLauncherOpen) {
      // @ts-ignore
      const launcher = yield select(launcherSelector);
      // @ts-ignore
      const launcherCardIds = [VIRTUAL_CARDS.MESSAGES._id, ...launcher.cardIds.filter((id: string) => id !== VIRTUAL_CARDS.MESSAGES._id)];
      yield put(setLauncherState({ cardIds: launcherCardIds, hideOnMouseLeave: false }));
    }
  }
}

function* closeLauncherSaga() {
  // @ts-ignore
  const previewMode = yield select(rpPreviewModeSelector);
  if (previewMode !== 'none') {
    return;
  }

  yield put(setLauncherState({ open: false }));
}

function* navigateViewSaga(action: ReturnType<typeof navigateView>) {
  const { viewId } = action.payload;
  // @ts-ignore
  const previewMode = yield select(rpPreviewModeSelector);

  if (previewMode === 'viewsview') {
    yield put(navigateDashboardView({ viewId }));
    return;
  }

  yield put(navigate({ viewId }));
}

function floaterIgnoredCountSaga(action: Action<{ count: number | null }>) {
  const ignoredCount = action.payload.count;
  if (!ignoredCount || ignoredCount <= 0) {
    customWindow.localStorage.removeItem(settings.floaterIgnoredCountStorageKey);
  } else {
    customWindow.localStorage.setItem(settings.floaterIgnoredCountStorageKey, ignoredCount.toString());
  }
}

function floaterIgnoredLastSaga(action: Action<{ last: number | null }>) {
  const timestamp = action.payload.last;
  if (!timestamp || timestamp <= 0) {
    customWindow.localStorage.removeItem(settings.floaterIgnoredLastStorageKey);
  } else {
    customWindow.localStorage.setItem(settings.floaterIgnoredLastStorageKey, timestamp.toString());
  }
}

function floaterClosedLastSaga(action: Action<{ last: number | null }>) {
  const timestamp = action.payload.last;
  if (!timestamp || timestamp <= 0) {
    customWindow.localStorage.removeItem(settings.floaterClosedLastStorageKey);
  } else {
    customWindow.localStorage.setItem(settings.floaterClosedLastStorageKey, timestamp.toString());
  }
}

export default function* uiSaga() {
  yield all([
    takeEvery(messageSent, messageSentSaga),
    takeEvery(closeLauncher, closeLauncherSaga),
    takeEvery(navigateView, navigateViewSaga),
    takeEvery(floaterIgnoredCount, floaterIgnoredCountSaga),
    takeEvery(floaterIgnoredLast, floaterIgnoredLastSaga),
    takeEvery(floaterClosedLast, floaterClosedLastSaga)
  ]);
}
